export default {
  isFetchedAllStocks(state) {
    return Array.isArray(state.items) ?
      state.totalCount === state.items.length :
      false;
  },

  isFetchedToFront(state) {
    if (state.items.length > 0) {
      const firstStock = state.items[0];
      return parseInt(firstStock.rownum, 10) === 1;
    }
    return true;
  },

  isFetchedToEnd(state) {
    if (state.items.length > 0) {
      const lastStock = state.items[state.items.length - 1];
      return state.totalCount === parseInt(lastStock.rownum, 10);
    }
    return true;
  },

  frontCursor(state) {
    if (state.items.length > 0) {
      const firstStock = state.items[0];
      return parseInt(firstStock.rownum, 10);
    }
    return null;
  },

  endCursor(state) {
    if (state.items.length > 0) {
      const lastStock = state.items[state.items.length - 1];
      return parseInt(lastStock.rownum, 10);
    }
    return null;
  },

  stockFilters(state) {
    return {
      ...state.filters,

      areaMin: parseInt(state.filters.areaMin, 10),
      areaMax: parseInt(state.filters.areaMax, 10),
      sellMin: parseInt(state.filters.sellMin, 10),
      sellMax: parseInt(state.filters.sellMax, 10),
      rentMin: parseInt(state.filters.rentMin, 10),
      rentMax: parseInt(state.filters.rentMax, 10),
      ftSellMin: parseInt(state.filters.ftSellMin, 10),
      ftSellMax: parseInt(state.filters.ftSellMax, 10),
      ftRentMin: parseInt(state.filters.ftRentMin, 10),
      ftRentMax: parseInt(state.filters.ftRentMax, 10),
    };
  },
};
